export const sessionStorage = {
  set(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) { console.error("Error saving:", e); }
  },
  get(key) {
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (e) { console.error("Error reading:", e); return null; }
  },
  remove(key) {
    try { window.sessionStorage.removeItem(key); } catch (e) { console.error("Error removing:", e); }
  },
};

export const STORAGE_KEYS = {
  AUTH_IDENTITY: "auth_identity",
  AUTH_TOKEN: "auth_token",
  // Set by api/auth.js logout() when a refresh is rejected: AdminAuthGate shows
  // "Your link has expired" while it is set. Never wipes the token; cleared whenever
  // the stored token changes (a refresh, a fresh admin link).
  AUTH_LOGOUT_REASON: "auth_logout_reason",
  // { exp, nbf, receivedAt } of the token the last refresh returned (api/auth.js
  // issuedRecord): how long it has left without trusting the device clock's offset.
  AUTH_TOKEN_ISSUED: "auth_token_issued",
};
